import { FC, useEffect } from 'react';
import VerticalNavigationMenuOption from 'components/navigation/verticalNavigation/VerticalNavigationMenuOption';
import { VerticalMenuItemWrapper } from '../VerticalMenuItemWrapper';
import { useTranslation } from 'react-i18next';

const BeamerChangelogIcon: FC = () => (
  <>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3256_1697)">
        <path
          d="M7.25391 8.76953C6.375 10.3164 5.8125 11.8984 5.8125 13.1992C5.8125 16.8203 8.51953 19.5625 12 19.5625C15.4102 19.5625 18.1875 16.8203 18.1875 13.1992C18.1875 12.1797 17.8008 10.8086 17.168 9.47266C16.6055 8.20703 15.8672 7.08203 15.1641 6.34375C15.0234 6.51953 14.8477 6.76562 14.6367 7.01172C14.5664 7.15234 14.4609 7.29297 14.3555 7.43359C14.2148 7.64453 14.0391 7.89062 13.9336 8.03125C13.793 8.24219 13.5469 8.34766 13.2656 8.38281C13.0195 8.38281 12.7734 8.24219 12.5977 8.03125C12.4922 7.89062 12.3516 7.71484 12.2109 7.57422C11.543 6.69531 10.7695 5.71094 10.1016 5.04297C9.15234 5.95703 8.09766 7.29297 7.25391 8.76953ZM11.1211 3.67188C11.7891 4.30469 12.5625 5.25391 13.2305 6.09766L13.2656 6.0625C13.5117 5.67578 13.8281 5.25391 14.1094 4.97266C14.707 4.44531 15.5859 4.44531 16.1836 4.97266C17.0977 5.88672 18.0117 7.29297 18.6797 8.76953C19.3828 10.2109 19.875 11.8281 19.875 13.1992C19.875 17.7344 16.3594 21.25 12 21.25C7.57031 21.25 4.125 17.6992 4.125 13.1992C4.125 11.4414 4.82812 9.57812 5.77734 7.92578C6.72656 6.27344 7.95703 4.72656 9.08203 3.67188C9.67969 3.14453 10.5586 3.14453 11.1211 3.67188ZM12.0352 17.875C9.82031 17.875 8.0625 16.4688 8.02734 14.043C8.02734 12.9883 8.625 12.0391 9.82031 10.5625C10.0664 10.2812 10.4883 10.2812 10.6992 10.5625C11.2969 11.3008 12.3164 12.6367 12.9141 13.375C13.125 13.6562 13.5469 13.6562 13.7578 13.375L14.6719 12.3555C14.8828 12.0742 15.3047 12.1094 15.4453 12.4258C16.3242 14.043 15.9375 16.1172 14.4609 17.1367C13.7227 17.6289 12.9492 17.875 12.0352 17.875Z"
          fill="#181B1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_3256_1697">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);

type BeamerChangelogProps = {
  variant?: 'default' | 'mobile';
};

const BeamerChangelog: FC<BeamerChangelogProps> = ({ variant = 'default' }) => {
  const { t } = useTranslation();

  useEffect(() => {
    window.Beamer?.init();
  }, []);

  return variant === 'mobile' ? (
    <button
      type="button"
      className="beamerTrigger tw-relative tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0"
      data-name="navbar_beamer-changelog"
      data-cy="beamer-button"
      aria-label={t('navigation.userSubActions.whatsNew')}
      id="beamer-button"
    >
      <BeamerChangelogIcon />
    </button>
  ) : (
    <button
      type="button"
      className="beamerTrigger tw-relative tw-mx-auto tw-flex tw-w-full tw-cursor-pointer tw-justify-center tw-border-0 tw-bg-transparent"
      data-name="navbar_beamer-changelog"
      data-cy="beamer-button"
      id="beamer-button"
    >
      <VerticalMenuItemWrapper>
        <VerticalNavigationMenuOption
          label={t('navigation.userSubActions.whatsNew')}
          icon={<BeamerChangelogIcon />}
          disableTooltip
        />
      </VerticalMenuItemWrapper>
    </button>
  );
};

export default BeamerChangelog;
